import { render } from "./NavbarPublicEducational.vue?vue&type=template&id=265ea888&scoped=true"
const script = {}

import "./NavbarPublicEducational.vue?vue&type=style&index=0&id=265ea888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265ea888"]])

export default __exports__